export default __webpack_public_path__ + "static/d3-edcd1863cfceaa329808e1fa310e366c.png";